import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Text } from '@/Components/Preferences/PreferencesComponents/Content';
import { useApplication } from '@/Components/ApplicationProvider';
import { c } from 'ttag';
const U2FDescription = ({ is2FAEnabled }) => {
    const application = useApplication();
    if (application.sessions.getUser() === undefined) {
        return (_jsx(Text, { children: c('B6.Preferences.Security.Info')
                .t `Sign in or register for an account to configure hardware security keys.` }));
    }
    return (_jsxs("div", { children: [_jsx(Text, { children: c('B6.Preferences.Security.Info').t `Authenticate with a hardware security key such as YubiKey.` }), !application.isFullU2FClient && (_jsx(Text, { className: "italic", children: c('B6.Preferences.Security.Info')
                    .t `Please visit the web app in order to add a hardware security key.` })), !is2FAEnabled && (_jsx(Text, { className: "italic", children: c('B6.Preferences.Security.Info')
                    .t `You must enable two-factor authentication before adding a hardware security key.` }))] }));
};
export default observer(U2FDescription);
